// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-menu__list {\n  display: flex;\n}\n\n.app-menu__item {\n  list-style: none;\n}\n\n.app-menu__link {\n  color: #595959;\n  font-family: sans-serif;\n  margin-right: 1rem;\n  text-decoration: none;\n}\n\n.app-menu__link:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
